import React from 'react';
import { useTranslation } from 'react-i18next';
import TextField from '../../../../components/common/TextField';
import { formatNumber } from '../../../../common/Util';

//주택임차차입금, 장기주택저당차입금
const HousingDetailItem = ({ inputList, dataList, setDataList, handleChange }) => {
  const { t } = useTranslation();

  return (
    <div className="displayFlexColumn" style={{ gap: '16px' }}>
      {inputList.map((item, index) => (
        <TextField
          label={item.label}
          key={index}
          size="small"
          color={item.color}
          // variant={item.variant}
          message={item.message}
          value={formatNumber(dataList[item.key])}
          onChange={handleChange}
          name={item.key}
          disabled={item.disabled}
          variant={item.disabled ? 'contained' : 'outline'}
          inputStyle={{ backgroundColor: item.color == 'secondary' ? 'var(--Primary-100)' : '' }}
        />
      ))}
    </div>
  );
};

export default HousingDetailItem;
